import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Slider from "react-slick";
import useMediaQuery from '@material-ui/core/useMediaQuery'
import NextArrow from '../ui/NextArrow'
import PrevArrow from '../ui/PrevArrow'

const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
//    padding: theme.spacing(0, 3),
  },
  carouselItem:{
    // padding: "0 80px",
    maxWidth: 1280,
    margin:"0 auto",
    zIndex: 0,
    // marginTop: theme.spacing(3),
    [theme.breakpoints.between('md','sm')]:{
      marginTop: theme.spacing(3),
      padding: 0,
    },
    [theme.breakpoints.down('xs')]:{
      // marginRight: theme.spacing(1) * -2,
      // marginLeft: theme.spacing(1) * -2,
      marginBottom: theme.spacing(3)
    }
  },
});

const Carousel = (props) => {
  const { theme, classes, color, item_size='medium', item_count, item_component_type, createContentBlock, items, activeKey } = props

  let removeNotFullRow = false
  let smUp = useMediaQuery(theme.breakpoints.up('sm'))
  let mdUp = useMediaQuery(theme.breakpoints.up('md'))
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'))
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'))
  let spacing
  let itemsPerRow
  let itemScroll
  let centerMode
  let variableWidth
  let slidesPerRow
  let dots = false
  let arrows = true
  if (item_size == 'xs') {
    if (xlUp) {
      itemsPerRow = 6
      spacing = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
      dots=true
      arrows=false
    }else if (lgUp) {
      itemsPerRow = 6
      spacing = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
      dots=true
      arrows=false
    }else if (mdUp) {
      itemsPerRow = 4
      spacing = 3
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
      dots=true
      arrows=false
    }
    else if (smUp) {
      itemsPerRow = 3
      spacing = 2
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
      dots=true
      arrows=false
    }
    else {
      itemsPerRow = 2
      spacing = 1
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2 
      dots=true
      arrows=false
    }
  }else if (item_size == 's') {
    if (xlUp) {
      itemsPerRow = 6
      spacing = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
    }else if (lgUp) {
      itemsPerRow = 5
      spacing = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
    }else if (mdUp) {
      itemsPerRow = 4
      spacing = 3
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
    }
    else if (smUp) {
      itemsPerRow = 3
      spacing = 2
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2
    }
    else {
      itemsPerRow = 2
      spacing = 1
      itemScroll = 3
      centerMode = true
      variableWidth = false
      slidesPerRow = 2 
    }
  }
  else if (item_size == 'l') {
    if (xlUp) {
      itemsPerRow = 2
      spacing = 3
      slidesPerRow = 1
    }else if (lgUp) {
      itemsPerRow = 2
      spacing = 3
      slidesPerRow = 1
    }else if (mdUp) {
      itemsPerRow = 2
      spacing = 4
      itemScroll = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }
    else if (smUp) {
      itemsPerRow = 2
      spacing = 2
      itemScroll = 1
      centerMode = true
      variableWidth = false
      slidesPerRow = 1
    }
    else {
      itemsPerRow = 1
      spacing = 1
      itemScroll = 1
      centerMode = true
      variableWidth = false
      slidesPerRow = 1
    }    
  }else if (item_size == 'xl') {
    if (xlUp) {
      itemsPerRow = 1
      spacing = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }else if (lgUp) {
      itemsPerRow = 1
      spacing = 1
      centerMode = true
      variableWidth = false
      slidesPerRow = 1
    }else if (mdUp) {
      itemsPerRow = 1
      spacing = 1
      itemScroll = 1
      centerMode = true
      variableWidth = false
      slidesPerRow = 1
    }
    else if (smUp) {
      itemsPerRow = 1
      spacing = 1
      itemScroll = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }
    else {
      itemsPerRow = 1
      spacing = 1
      itemScroll = 1
      centerMode = true
      variableWidth = false
      slidesPerRow = 1
    }    
  }

  else {
    if (mdUp) {      
      itemsPerRow = 3
      spacing = 3
      itemScroll = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }
    else if (smUp) {
      itemsPerRow = 3
      spacing = 2
      itemScroll = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }
    else {
      itemsPerRow = 2
      spacing = 1
      itemScroll = 1
      centerMode = false
      variableWidth = false
      slidesPerRow = 1
    }
  }

  let itemAttributes = {}

  const createItemBlock = (itemData) => {
    itemAttributes = {itemKey:itemData.key, itemsPerRow:itemsPerRow, activeKey: activeKey}
    return createContentBlock(item_component_type, itemData, 0, itemAttributes)
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: itemsPerRow,
    arrows: true,
    // slidesToScroll: itemScroll,
    autoplay: true,
    autoplaySpeed: 5000,
    variableWidth: variableWidth,
    // centerMode: centerMode,
    initialIndex: 0,
    pauseOnHover:false,
    nextArrow: <NextArrow type='course'/>,
    prevArrow: <PrevArrow type='course'/>,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          // slidesToShow: 1,
          // slidesToScroll: 2,
          arrows: arrows,
          rows: 1,
          slidesPerRow: slidesPerRow,
          dots: dots,
          centerMode: true,
          infinite: true,
          centerPadding: "-5px",
          slidesToShow: slidesPerRow,
        }
      },
    ]
  };
  
  let filteredItems = items
  if (items !== undefined && removeNotFullRow) {
    let rowCount = Math.floor(items.length / itemsPerRow)
    if (rowCount <= 0)
      filteredItems = items
    else
      filteredItems = items.slice(0, rowCount * itemsPerRow)
  }
      
  return (
    <Slider {...settings} className={classes.carouselItem}>
        { filteredItems !== undefined && filteredItems.map((item, index) => (
            createItemBlock(item, index)
        ))}
    </Slider>
  )
}

Carousel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Carousel);